
import Faq from "@/types/Faq";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import {computed, defineComponent, PropType, ref, watch} from "vue";
import  { MarkdownContent }   from "hjelseth-richeditor";
import {mdiEyeCheck,mdiLoading, mdiPencil, mdiTrashCan} from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
// @ts-ignore
import IconButton from "@/Components/Buttons/IconButton.vue";
import CategoryPill from "@/Components/General/CategoryPill.vue";
import ButtonGroup from "@/Components/Buttons/ButtonGroup.vue";
import UserType from "@/types/User";
import {Option} from "@/types/LevelsSelectTypes";
import Modal from "@/Components/General/Modal.vue";
import Button from "@/Components/Buttons/Button.vue";
import {Link, usePage} from "@inertiajs/inertia-vue3";
import AppLayout from "@/Layouts/AppLayout.vue";
import {Inertia} from "@inertiajs/inertia";
import FaqCategory from "@/types/FaqCategory";
import Messages from "@/Components/General/Messages.vue";
import Card from "@/Components/General/Card.vue";

dayjs.extend(calendar);

export default defineComponent({
  layout: AppLayout,
  components: {
    Card,
    Messages,
    Link,
    SvgIcon,
    IconButton,
    CategoryPill,
    MarkdownContent,
    ButtonGroup,
    Modal,
    Button,
  },
  props: {
    faq: {
      type: Object as PropType<Faq>,
      required: true,
    },
    categories: {
      type: Object as PropType<FaqCategory[]>,
      default: () => [],
    },
  },
  setup(props) {
    const selectedOptionId = ref(props.faq.category?.id ?? 0);

    const createdRelativeDate = computed(() => {
      return dayjs(props.faq.created_at).calendar();
    });
    const page = usePage<any>();
    const user: UserType = page.props.value.user;

    const createdAbsoluteDate = computed(() => {
      return dayjs(props.faq.created_at).format("L LT");
    });

    const updatedRelativeDate = computed(() => {
      return dayjs(props.faq.updated_at).calendar();
    });

    const updatedAbsoluteDate = computed(() => {
      return dayjs(props.faq.updated_at).format("L LT");
    });


    function mapCategories(categories: FaqCategory[], levels: number): Option[] {

      if (levels == 0) {
        return [];

      }
      return categories.map((category: FaqCategory) => ({
        id: category.id,
        label: category.title,
        parent_id: category.parent_id,
        expandable: category.sub_categories && category.sub_categories.length > 0,
        options: category.sub_categories ? mapCategories(category.sub_categories, levels - 1) : [],
      }))
    }

    const options = mapCategories([
      {
        id: 0,
        title: "Alle kategorier",
        sub_categories: [],
        parent_id: null,
      },
      ...props.categories] as any, 3);

    const goToCategory = () => {

      if (!selectedOptionId.value) {
        Inertia.get(route("faq.index"));
        return;
      }

      Inertia.get(route("faq.index", {category: selectedOptionId.value}));
    };


    const displayCategories = computed(() => {
      return [
        {
          id: null,
          title: "Alle kategorier",
        },
        ...props.categories,
      ];
    });
    watch(
      () => selectedOptionId.value,
      function () {
        if (selectedOptionId.value || selectedOptionId.value === 0) {
          goToCategory();
        }
      }
    );

    const deleteOpen = ref(false);
    const deleteLoading = ref(false);

    //Test
    const deleteFaq = () => {
      deleteLoading.value = true;
      Inertia.delete(
        route("faq.destroy", {
          faq: props.faq.id,
        }),
        {
          preserveScroll: true,
          onFinish: () => {
            deleteLoading.value = false;
          }
        }
      );
    };


    return {
      displayCategories,
      editIcon: mdiPencil,
      createdRelativeDate,
      createdAbsoluteDate,
      updatedAbsoluteDate,
      updatedRelativeDate,
      mdiTrashCan,
      deleteOpen,
      deleteLoading,
      deleteFaq,
      options,
      selectedOptionId,
      mdiLoading,
      eyeIcon:mdiEyeCheck

    };
  },
});
